import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { provideAppConfig } from '@xt/core/app-config';
import {
  isNativeClient,
  processAppConfigByNativeClientStatus,
} from './app/shared/helpers/native-client.helper';

if (environment.production) {
  enableProdMode();
}

fetch('/assets/app-config.json')
  .then((response) => response.json())
  .then((config) => {
    // this checks for native:: entries and uses them if client is currenly running on native
    const processedConfig = processAppConfigByNativeClientStatus(
      config,
      isNativeClient(),
    );

    platformBrowserDynamic([provideAppConfig(processedConfig)])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
